// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"c72e1bf0","984":"e9ae2aac"}[chunkId] + ".chunk.css";
};